/*
  Trail Cam Collective — loan scheme page behaviour.

  Progressive enhancement only. All six process steps are rendered as text by
  Liquid and stay visible at all times, so with JS off the page reads in full;
  the first illustration simply stays put.

  The illustration is a supplementary preview, hidden entirely below the
  two-column breakpoint. It sticks beside the list and follows whichever step
  the reader has scrolled to, and can also be driven directly by hover (on
  fine-pointer devices), click, and arrow keys / Home / End as a standard
  tablist. Direct input wins for a moment so a click is not undone by a
  scroll event fired on the same gesture.
*/
(function () {
  'use strict';

  var finePointer =
    window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* The sticky preview is only rendered at this width, so the scroll-following
     behaviour is pointless below it. */
  var twoColumn = window.matchMedia ? window.matchMedia('(min-width: 769px)') : null;

  function initProcess(root) {
    var lists = root.querySelectorAll('[data-tcc-steps]');

    Array.prototype.forEach.call(lists, function (list) {
      if (list.tccBound) return;
      list.tccBound = true;

      var tabs = Array.prototype.slice.call(list.querySelectorAll('[data-tcc-step]'));
      var scope = list.closest('[data-tcc-process]') || root;
      var images = Array.prototype.slice.call(scope.querySelectorAll('[data-tcc-step-img]'));
      var caption = scope.querySelector('[data-tcc-step-caption]');
      if (!tabs.length) return;

      var current = -1;
      /* Explicit input wins briefly, so a click is not immediately undone by
         the scroll handler when the page has not actually moved. */
      var suppressScrollUntil = 0;

      function select(index, moveFocus) {
        if (index === current) {
          if (moveFocus) tabs[index].focus();
          return;
        }
        current = index;

        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          /* Roving tabindex: only the selected tab is in the tab order. */
          tab.setAttribute('tabindex', on ? '0' : '-1');
        });

        images.forEach(function (img, i) {
          img.classList.toggle('is-active', i === index);
        });

        if (caption) {
          caption.textContent = tabs[index].getAttribute('data-tcc-step-label') || '';
        }

        if (moveFocus) tabs[index].focus();
      }

      function selectByUser(index) {
        suppressScrollUntil = Date.now() + 700;
        select(index, false);
      }

      /* Follow the step the reader has arrived at: whichever step's midpoint
         sits closest to a line in the upper-middle of the viewport. */
      function selectFromScroll() {
        if (twoColumn && !twoColumn.matches) return;
        if (Date.now() < suppressScrollUntil) return;

        var line = window.innerHeight * 0.42;
        var best = 0;
        var bestDistance = Infinity;

        for (var i = 0; i < tabs.length; i++) {
          var rect = tabs[i].getBoundingClientRect();
          var distance = Math.abs(rect.top + rect.height / 2 - line);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        }

        select(best, false);
      }

      var queued = false;
      function onScroll() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          selectFromScroll();
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          selectByUser(i);
        });

        if (finePointer) {
          tab.addEventListener('mouseenter', function () {
            selectByUser(i);
          });
        }

        tab.addEventListener('keydown', function (event) {
          var next = null;

          switch (event.key) {
            case 'ArrowDown':
            case 'ArrowRight':
              next = (i + 1) % tabs.length;
              break;
            case 'ArrowUp':
            case 'ArrowLeft':
              next = (i - 1 + tabs.length) % tabs.length;
              break;
            case 'Home':
              next = 0;
              break;
            case 'End':
              next = tabs.length - 1;
              break;
            case 'Enter':
            case ' ':
              next = i;
              break;
            default:
              return;
          }

          event.preventDefault();
          suppressScrollUntil = Date.now() + 700;
          select(next, true);
        });
      });

      /* Trust the markup's starting state rather than resetting it. */
      var initial = 0;
      tabs.forEach(function (tab, i) {
        if (tab.getAttribute('aria-selected') === 'true') initial = i;
      });
      select(initial, false);

      /* If the page loads part-scrolled (anchor link, restored position), sync
         to wherever the reader actually is. */
      selectFromScroll();
    });
  }

  function init(scope) {
    initProcess(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor re-renders sections in place. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
